import { createSlice } from "@reduxjs/toolkit";

const newSlice = createSlice({
  name: "news",
  initialState: {
    isFetching: false,
    news: [],
    error: []
  },
  reducers: {
    statusNewsStart: (state) => {
      state.isFetching = false
      state.error = []
    },
    statusNewsSuccess: (state, action) => {
      state.isFetching = false
      state.news = action.payload
      state.error = []
    },
    statusNewsFailure: (state, action) => {
      state.isFetching = false
      state.error = action.payload
    }
  }
})


export const { 
  statusNewsStart,
  statusNewsSuccess,
  statusNewsFailure 
} = newSlice.actions

export default newSlice.reducer